<template>
  <div class="option-list-holder">
    <div class="list-options" ref="options">
      <div v-if="unPromotedOptions.length > 0" class="pipe-option-banner">Company Pipes</div>
      <Option v-for="(option, index) in unPromotedOptions" :key="index" :option="option" :num="index"
        :ref="'option' + option.id" @mouseover="handleMouseOver($event)" @mouseout="handleMouseOut($event)"
        @click="handleOptionClick($event, option)" />
      <div class="pipe-option-banner">Promoted Pipes</div>
      <Option v-for="(option, index) in promotedOptions" :key="index" :option="option" :num="index"
        :ref="'option' + option.id" @mouseover="handleMouseOver($event)" @mouseout="handleMouseOut($event)"
        @click="handleOptionClick($event, option)" />
    </div>
  </div>
</template>

<script>
import { usePipeStore } from '@/store/PipeStore';
import Option from '@/components/nelson/Option';

export default {
  name: 'OptionList',
  data () {
    return {
      visible: false,
      // todo: select to default pipe
      selected: { description: 'choose' },
      target: null
    };
  },
  props: [
    'type',
    'segment'
  ],
  mounted () {
    if (this.$props.segment !== undefined && this.$props.segment.id !== undefined) {
      this.selected = usePipeStore().getPipeById(this.$props.segment.id);
    }
    this.updatedSelection();
  },
  watch: {
    getEditedPipe: {
      handler () {
        this.PipeOptionTarget.classList.remove('selected');
        this.updatedSelection();
      },
      deep: true
    },
  },
  emits: [
    'overflow'
  ],
  components: {
    Option
  },
  computed: {
    optionsVisible () {
      return this.visible;
    },
    optionData () {
      var pipes = usePipeStore().getPipes;
      // pipes.sort((a, b) => a.isPromoted - b.isPromoted);
      return pipes;
    },
    promotedOptions () {
      const promotedPipes = this.optionData.filter((item) => item.isPromoted === true);
      return promotedPipes;
    },
    unPromotedOptions () {
      const unPromotedPipes = this.optionData.filter((item) => item.isPromoted === false);
      return unPromotedPipes;
    },
    getEditedPipe () {
      return usePipeStore().getEditedPipe;
    },
    PipeOptionTarget () {
      return usePipeStore().getPipeOptionTarget;
    }
  },
  methods: {
    handleOptionsDown (e) {
      e.stopImmediatePropagation();
    },
    handleMouseOver (e) {
      if (e.target !== this.PipeOptionTarget) {
        e.target.classList.add('highlight');
      }
    },
    handleMouseOut (e) {
      e.target.classList.remove('highlight');
    },
    handleOptionClick (e, option) {
      const pipeStore = usePipeStore();
      pipeStore.setPipeMode('default');
      if (e.target === pipeStore.getPipeOptionTarget) { return; }
      if (pipeStore.getPipeOptionTarget !== null) {
        this.PipeOptionTarget.classList.remove('selected');
      }
      pipeStore.setAllowPipeEdit(false, 'edit');
      pipeStore.setEditedPipe(option);
    },
    updatedSelection () {
      const pipeStore = usePipeStore();

      if (pipeStore.getEditedPipe === null) {
        return;
      }

      if (!this.$refs['option' + pipeStore.getEditedPipe.id]) {
        return;
      }

      let selection = this.$refs['option' + pipeStore.getEditedPipe.id][0].$el;

      selection.classList.add('selected');
      pipeStore.setPipeOptionTarget(selection);
    }
  }
};
</script>

<style scoped>
.num-label {
  font-size: .8em;
}
.list-options {
  overflow-y: auto;
  width: 100%;
  background-color: white;
}
.pipe-option-banner {
  background-color: #D3D3D3;
  font-weight: bold;
  padding-left: 5px;
}
.option-list-holder {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  flex-direction: column;
}
.selected {
  /* background-color: #d7d7d7; */
  background-color: #E7E7E7;
}
.highlight {
  background-color: #e7e7e7;
}
</style>